import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import { OrderListPage, OrderEditPage, OrderCreatePage } from './imports';

export const orderRoutes = [
  {
    path: 'orders',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrderListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrderListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.CREATE}
          >
            <OrderCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.ORDER}
            access={OrionAccess.VIEW}
          >
            <OrderEditPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
